
















import { Vue, Component } from 'vue-property-decorator';

import UpdateIdentityDocumentViewModel
  from '@/vue-app/view-models/views/update-identity-document/update-identity-document-view-model';

@Component({
  name: 'UpdateIdentityDocument',
  components: {
    UpdateIdentityDocumentLoadingPage: () => import('@/vue-app/components/update-identity-document/UpdateIdentityDocumentLoadingPage.vue'),
    UpdateIdentityDocumentVerifyIdentify: () => import('@/vue-app/components/update-identity-document/VerifyIdentity.vue'),
    IdentityDocumentUpdatedConfirmation: () => import('@/vue-app/components/update-identity-document/IdentityDocumentUpdatedConfirmation.vue'),
  },
})
export default class UpdateIdentityDocument extends Vue {
  view_model = new UpdateIdentityDocumentViewModel();

  async mounted() {
    if (this.$route?.query?.token) {
      await this.view_model.initialize(this.$route?.query?.token.toString());
    } else {
      this.view_model.goToLoginPage();
    }
  }

  destroyed() {
    this.view_model.deleteTokenFromStorage();
  }
}

